import React, { FC } from 'react';
import { SVGS } from '../../../../assets/images';
import { BaseMenuItem } from '../menu-item';
import { Lx } from '../../../../i18n/consts';

interface Props {
    open: boolean;
    toggle: () => void;
}

const HideButton: FC<Props> = (props) => {
    const { open, toggle } = props;

    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
        event.preventDefault();
        toggle();
    };

    return (
        <BaseMenuItem
            name={Lx.General.HIDE_MENU}
            open={open}
            defaultSvg={<SVGS.UnfoldIcon />}
            secondarySvg={<SVGS.FoldIcon />}
            callback={handleClick}
        />
    );
};

export default HideButton;
